/// <reference types="./arrow_dropdown.d.mts" />
import * as $svg from "../../ds/internals/svg.mjs";

export function arrow_dropdown() {
  return $svg.square(
    20,
    "<path d=\"M10.0002 12.5L6.46436 8.96416L7.64352 7.78583L10.0002 10.1433L12.3569 7.78583L13.536 8.96416L10.0002 12.5Z\" fill=\"currentColor\"/>",
  );
}
